/* "Complete the ritual": adds the product on the page plus the ticked pair products to the cart in one request,
   then opens the cart drawer (or goes to the cart page). The saving itself is an automatic discount in Shopify. */
if (!customElements.get('bundle-pair')) {
  customElements.define(
    'bundle-pair',
    class BundlePair extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-bundle-add]');
        this.error = this.querySelector('[data-bundle-error]');
        this.button?.addEventListener('click', () => this.add());
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
      }

      async add() {
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        const mainId = form?.querySelector('input[name="id"]')?.value;
        const picked = [...this.querySelectorAll('[data-bundle-pick]:checked')].map(
          (box) => box.closest('.ws-bundle__item').querySelector('[data-bundle-variant]').value
        );
        if (picked.length === 0) return this.showError(this.dataset.errorNone);
        if (!mainId || picked.some((id) => !id)) return this.showError(this.dataset.errorVariant);
        this.error.hidden = true;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: [mainId, ...picked].map((id) => ({ id: Number(id), quantity: 1 })) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        this.button.setAttribute('aria-disabled', 'true');
        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (!response.ok || data.status) return this.showError(data.description || data.message || '');
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle', cartData: data });
          if (cart) cart.renderContents(data);
          else window.location = routes.cart_url;
        } catch (e) {
          this.showError(this.dataset.errorVariant);
        } finally {
          this.button.removeAttribute('aria-disabled');
        }
      }
    }
  );
}
